<template>
  <ul class="list_rpt_type">
    <li class="item_rpt_type" :class="{ curRpt: curIdx === 3 }" @click="goPage(3, 'personRpt')">个人</li>
    <li class="item_rpt_type" :class="{ curRpt: curIdx === 2 }" @click="goPage(2, 'groupRpt')">小组</li>
    <li class="item_rpt_type" :class="{ curRpt: curIdx === 1 }" @click="goPage(1, 'achievementRpt')">门店</li>
  </ul>
</template>

<script>
export default {
    props: {
        curIdx: {
            type: Number,
            default: 3
        }
    },
    data () {
        return {

        }
    },
    methods: {
        goPage (val, pageName) {
            this.$emit('goPage', val, pageName)
        }
    }
}
</script>

<style lang="less" scoped>

</style>
